import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { OvertimeService } from '../../services/overtime.service';
import { AuthService } from '../../services/auth.service';
import { PermissionService } from '../../services/permission.service';

import { Utils } from '../../util';
import { toast } from 'angular2-materialize';

@Component({
    selector: 'app-read-overtime',
    templateUrl: './read-overtime.component.html',
    styleUrls: ['./read-overtime.component.css', '../../app.component.css']
})

export class ReadOvertimeComponent implements OnInit {
    allowed: boolean = false;
    permission: any = {};

    overtimes: any[] = [];

    data: Array<any>;
    rows: Array<any> = [];
    columns: Array<any> = [
        { title: 'Fecha y hora asignación', className: 'center', name: 'name' },
        { title: 'Empleado', name: 'employeeName' },
        { title: 'Fecha del trabajo', className: 'center', name: 'workDate' },
        { title: 'Cant. horas', className: 'center', name: 'hours' },
        { title: 'Usuario que autorizó', name: 'authorizeName' },
        { title: 'Usuario que capturó', name: 'userName' },
        { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
            { name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
              styleClass: 'btn-floating btn waves-effect light-green darken-1' },
            { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
              styleClass: 'btn-floating btn waves-effect red darken-2', }
        ] } }
    ];

    page = 1;
    itemsPerPage = 20;
    maxSize = 5;
    numPages = 1;
    length = 0;
    config: any = {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        api: {
            onEdit: this.onEdit.bind(this),
            onDelete: this.onDelete.bind(this)
        }
    };

    goSubs: any;

    permissions = [];
    permissionsSubs: any;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: OvertimeService,
        private authService: AuthService,
        private permissionService: PermissionService
    ) {
        let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
            permissionsSubs.unsubscribe();
            this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
            if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
            else this.allowed = true;
        });

        this.loadOvertimes();
    }

    ngOnInit() {

    }

    loadOvertimes() {
        this.goSubs = this.service.getOvertimes().subscribe(tempOvertimes => {
            this.goSubs.unsubscribe();

            this.overtimes = [];

            for (const idx in tempOvertimes) {
                tempOvertimes[idx].name = Utils.getDateTime(tempOvertimes[idx].assignationDate);
                tempOvertimes[idx].workDate = Utils.convertDatefromStringtoISOString(tempOvertimes[idx].workDate);

                this.overtimes.push(tempOvertimes[idx]);
            }

            this.data = this.overtimes;
            this.length = this.data.length;
            this.onChangeTable(this.config);
        });
    }

    onCellClick(data: any): any {
        this.router.navigate(['/vw_overtime/' + data.row.id$]);
    }

    onCreate(){
        if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
        this.router.navigate(['/add_overtime']);
    }

    onEdit(data: any) {
        if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000)
        this.router.navigate(['/edt_overtime/', data.row.id$]);
    }

    onDelete(data: any) {
        if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000)
        this.service.delOvertime(data.row.id$).then(res => {
            this.loadOvertimes();
        });
    }



    // *************** Table functionality *************** //
    changePage(page: any, data: Array<any> = this.data): Array<any> {
        let start = (page.page - 1) * page.itemsPerPage;
        let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;

        return data.slice(start, end);
    }

    changeSort(data: any, config: any): any {
        if (!config.sorting) {
            return data;
        }

        let columns = this.config.sorting.columns;
        let columnName: string;
        let sort: string;

        for (let i = 0; i < columns.length; i++) {
            if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
                columnName = columns[i].name;
                sort = columns[i].sort;
            }
        }

        if (!columnName) {
            return data;
        }

        // simple sorting
        return data.sort((previous: any, current: any) => {
            if (previous[columnName] > current[columnName]) {
                return sort === 'desc' ? -1 : 1;
            } else if (previous[columnName] < current[columnName]) {
                return sort === 'asc' ? -1 : 1;
            }

            return 0;
        });
    }

    changeFilter(data: any, config: any): any {
        let filteredData: Array<any> = data;

        this.columns.forEach((column: any) => {
            if (column.filtering) {
                filteredData = filteredData.filter((item: any) => {
                    return item[column.name].match(column.filtering.filterString);
                });
            }
        });

        if (!config.filtering) {
            return filteredData;
        }

        if (config.filtering.columnName) {
            return filteredData.filter((item: any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
        }

        let tempArray: Array<any> = [];

        filteredData.forEach((item: any) => {
            let flag = false;

            this.columns.forEach((column: any) => {
                if (item[column.name] &&
                    item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
                    flag = true;
                }
            });

            if (flag) {
                tempArray.push(item);
            }
        });

        filteredData = tempArray;

        return filteredData;
    }

    onChangeTable(config: any, page: any = {page: this.page, itemsPerPage: this.itemsPerPage}): any {
        if (config.filtering) {
            Object.assign(this.config.filtering, config.filtering);
        }

        if (config.sorting) {
            Object.assign(this.config.sorting, config.sorting);
        }

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);

        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.length = sortedData.length;
    }

}
